// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewTabs-TabsSkeleton_cls1__gRtb1","cls2":"PaymentViewTabs-TabsSkeleton_cls2__FWhrM PaymentViewTabs-TabsSkeleton_cls1__gRtb1"};